// Чекбокс с кастомным внешним видом
// т.к. оригинальный input[type='checkbox'] скрыт,
// то в тестах кликать нужно на label, а не на input

const template = /* html */`
    <label
        class="input-checkbox-btn flex gap-0_25"
        :class="nohover ? 'nohover' : ''"
        @click="nohover=true"
        @mouseleave="nohover=false"
    >
        <input
            class="original-checkbox-btn"
            hidden
            type="checkbox"
            :name="name"
            :checked="modelValue"
            @change="$emit('update:modelValue', $event.target.checked)"
        >
        <div :class="['custom-checkbox-btn', color]" />
        <span :class="['custom-checkbox-content', 'custom-checkbox-content-' + color]">
            <slot />
        </span>
    </label>
`;

export default {
    data() {
        return { nohover: false };
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: "",
        },
        color: {
            type: String,
            default: "light",
            validator(value) {
                return ["light", "dark"].includes(value);
            },
        },
    },
    emits: ["update:modelValue"],
    template,
};
